import PropTypes from 'prop-types';
import { createContext, useEffect, useReducer } from 'react';

// third-party
import { Chance } from 'chance';
import jwtDecode from 'jwt-decode';

// reducer - state management
import { LOGIN, LOGOUT } from 'contexts/auth-reducer/actions';
import authReducer from 'contexts/auth-reducer/auth';

// project import
import Loader from 'components/Loader';
import axios from 'utils/axios';
//import axiosProduction from 'utils/axios-xampp';
import { useApiFetcher } from 'utils/fetcher/ApiFetcher';
import { selectOptionsStoreUtils } from 'components/worten/FormFactory/selectOptionsStore';
import useTasksStore from 'stores/tasksStore';
import useNotificationsStore from 'contexts/notifications/notificationsStore';

//Role validator
import {NotAuthorized} from 'components/not-authorized';






const chance = new Chance();

// constant
const initialState = {
  isLoggedIn: false,
  isInitialized: false,
  user: null
};




//-------------------------------------
const verifyToken = (serviceToken) => {
  if (!serviceToken) {
    return false;
  }

  /*
  // Ya no se verifica la expiracion del token en el cliente, esto se hace en el servidor para manejar refresh session
  const decoded = jwtDecode(serviceToken);
  console.log("token expiration="+decoded.exp+" | now="+(Date.now() / 1000));
  return decoded.exp > Date.now() / 1000;
  */

  return true;
};




//-------------------------------------
const setSession = (serviceToken) => {
  if (serviceToken) {
    localStorage.setItem('serviceToken', serviceToken);
    //axiosProduction.defaults.headers.common.Authorization = `Bearer ${serviceToken}`;
  } else {
    localStorage.removeItem('serviceToken');
    //delete axiosProduction.defaults.headers.common.Authorization;
  }
};










//-------------------------------------
const JWTContext = createContext(null);

export const JWTProvider = ({ children }) => {
  const [state, dispatch] = useReducer(authReducer, initialState);
  const ApiFetcher = useApiFetcher();

  useEffect(() => {
    const init = async () => {
      try {
        let localToken = window.localStorage.getItem('serviceToken');
        if(localToken === null)
        {
          console.log("Token not exists in localStorage, logging out");
          logout();
        } else {
          console.log("Token exists in localStorage");
          
          const serviceToken = localToken;

          if (serviceToken && verifyToken(serviceToken)) 
          {
            //setSession(serviceToken);
            console.log("Token is valid, setting session");
            console.log();
            const userDecoded = jwtDecode(serviceToken);
            console.log("User data from API >");
            console.table(userDecoded);

            //This will trigger the utils/route-guard/ scripts
            dispatch({
              type: LOGIN,
              payload: {
                isLoggedIn: true,
                user: { 
                  role: Number(userDecoded.role), 
                  id: Number(userDecoded.id), 
                  name: userDecoded.nombre,
                  customVars: userDecoded.customVars,
                  id_empresas: Number(userDecoded.id_empresa),
                  id_vendedor: Number(userDecoded.id_vendedor),
                  // Pass through any initData if it exists in the token
                  ...(userDecoded.initData && { initData: userDecoded.initData })
                }
              }
            });
          } else {
            logout();
          }
        }
      } catch (err) {
        console.error(err);
        logout();
      }
    };
    

    

    // Clear localStorage to avoid issues with old tokens
    //console.log("Resetting localStorage"); setSession(null);window.localStorage.clear(); 

    console.log("calling init");
    init();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);




  //-----------------------------------
  const login = async (id, password, rememberMe = false) => {
    /* ORIGINAL CODE
    const response = await axios.post('/api/account/login', { email, password });
    const { serviceToken, user } = response.data;
    */


    ApiFetcher({
      url: '?section=user&action=login',
      type: 'POST',
      data: {id, password, rememberMe},
      showSuccessNotification: false,
      showErrorNotification: true,
      onSuccess: (payload) => {
        const user = payload;
        setSession(user.accessToken);
        dispatch({
          type: LOGIN,
          payload: {
            isLoggedIn: true,
            user: { 
                  role: Number(user.role), 
                  id: Number(user.id), 
                  name: user.nombre,
                  customVars: user.customVars,
                  id_empresas: Number(user.id_empresa),
                  id_vendedor: Number(user.id_vendedor),
                  // Pass through any initData if it exists
                  ...(user.initData && { initData: user.initData })
                }
          }
        });
      },
      onError: ()=>{console.warn("Login Fetch returned an error")}
    });
    
  };




  //-----------------------------------
  const register = async (email, password, firstName, lastName) => {
    // todo: this flow need to be recode as it not verified
    const id = chance.bb_pin();
    const response = await axios.post('/api/account/register', {
      id,
      email,
      password,
      firstName,
      lastName
    });
    let users = response.data;

    if (window.localStorage.getItem('users') !== undefined && window.localStorage.getItem('users') !== null) {
      const localUsers = window.localStorage.getItem('users');
      users = [
        ...JSON.parse(localUsers),
        {
          id,
          email,
          password,
          name: `${firstName} ${lastName}`
        }
      ];
    }

    window.localStorage.setItem('users', JSON.stringify(users));
  };




  //-----------------------------------
  const logout = () => {
    console.log("Logging out...");

    ApiFetcher({
      url: '?section=user&action=logout',
      type: 'POST',
      data: {},
      showSuccessNotification: false,
      showErrorNotification: true,
      onSuccess: (payload) => {
        dispatch({ type: LOGOUT });        
        setSession(null);
        localStorage.clear();
        
        // Reset all Zustand stores
        selectOptionsStoreUtils.resetStore();
        useTasksStore.getState().resetStore();
        useNotificationsStore.getState().resetStore();
      }, 
      onError: ()=>{console.warn("Login Fetch returned an error")}
    });
  };




  //-----------------------------------
  const ValidateRole = (userRole, authRoles) =>
  {
    //console.log("Validating roles: " + authRoles + " | User role="+userRole);
    
    if (authRoles.includes(userRole))
    {
      console.log("Authorized");
      return true;
    } else {
      console.log("Not Authorized");
      return <NotAuthorized role={userRole}/>;
    }
    
  }




  //-----------------------------------
  const resetPassword = async () => {};




  //-----------------------------------
  const updateProfile = () => {};



  //-----------------------------------
  if (state.isInitialized !== undefined && !state.isInitialized) {
    return <Loader />;
  }

  return <JWTContext.Provider value={{ ...state, login, logout, register, resetPassword, updateProfile, ValidateRole }}>{children}</JWTContext.Provider>;
};




JWTProvider.propTypes = {
  children: PropTypes.node
};

export default JWTContext;


